import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import buttonStyles from "@design-system/Button/Button.module.scss";
import { Tabs } from "@design-system/Tabs/Tabs";
import { CloseIcon } from "@icons";
import styles from "./Chat.module.scss";
import { ChatDrawerPanel, useChat } from "./Chat.context";
import { useIsAgentTabShown } from "./useIsAgentTabShown";

const CHAT_DRAWER_PANELS: readonly ChatDrawerPanel[] = ["chat", "agent"];

/**
 * The drawer's title row. With the Agent tab available (`useIsAgentTabShown`)
 * it is the full-width Chat / Agent tab bar (the top-bar chat toggle closes
 * the drawer); otherwise the legacy `Chat` title with the close button.
 */
export const ChatDrawerHeader = () => {
    const { close, panel, setPanel } = useChat();
    const isAgentTabShown = useIsAgentTabShown();

    if (isAgentTabShown) {
        return (
            <Tabs.Root
                value={panel}
                onValueChange={(value) => {
                    const next = CHAT_DRAWER_PANELS.find(
                        (candidate) => candidate === value,
                    );
                    if (next) {
                        setPanel(next);
                    }
                }}
            >
                <Tabs.List className={styles.drawerTabs}>
                    <Tabs.Tab value="chat" className={styles.drawerTab}>
                        Chat
                    </Tabs.Tab>
                    <Tabs.Tab value="agent" className={styles.drawerTab}>
                        Agent
                    </Tabs.Tab>
                </Tabs.List>
            </Tabs.Root>
        );
    }

    return (
        <div className={styles.title}>
            <span
                className={classNames(
                    buttonStyles.button,
                    buttonStyles.sm,
                    buttonStyles.link,
                )}
            >
                Chat
            </span>
            <Button
                iconOnly
                variant="primary"
                size="sm"
                onClick={close}
                aria-label="Close chat"
            >
                <CloseIcon />
            </Button>
        </div>
    );
};
